// extracted by mini-css-extract-plugin
module.exports = {"studentInfo":"style_studentInfo__17nH7"};